<template>
  <div class="list-product-item">
    <div class="detail flex flex-row">
      <div class="flex-auto">
        <div class="py-1 mt-1 text-sm">
          單價 ${{ product.price }}
          <span v-if="product.expired_date" class="text-xs ml-2">(Exp. {{ product.expired_date }})</span>
        </div>
        <div v-if="product.manages_inventory">
          <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
            庫存管理
          </span>
        </div>
      </div>
      <div class="w-24">
        <div
          class="counter"
          :class="{ highlight: (product.quantity > 0), readonly, modified }"
        >
          <button
            v-show="!readonly"
            class="text-gray-500"
            @click="$emit('updated', product.quantity > 1 ? (product.quantity - 1) : 0)"
          >-</button>
          <input
            type="number"
            class="text-center"
            :value="product.quantity"
            :readonly="readonly"
            @blur="el => $emit('updated', parseFloat(el.target.value || 0))"
          >
          <button
            v-show="!readonly"
            class="text-gray-500"
            @click="$emit('updated', product.quantity + 1)"
          >+</button>
        </div>
      </div>
    </div>
    <div v-if="product.manages_inventory" class="mt-1">
      <div v-for="inventory in product.inventories" :key="inventory.id" class="flex items-center py-1">
        <div class="flex-1 text-blue-500">
          {{ inventory.expired_date }}
          (MAX: {{ inventory.quantity }})
        </div>

        <div class="w-24">
          <div class="counter" :class="{ highlight: (inventory.order_quantity > 0), readonly, modified }">
            <button
              v-show="!readonly"
              class="text-gray-500"
              @click="$emit('updated-order-product-inventory-quantity', {
                inventory,
                quantity: inventory.order_quantity > 1 ? (inventory.order_quantity - 1) : 0,
              })"
            >-</button>
            <input
              type="number"
              class="text-center"
              :value="inventory.order_quantity"
              :readonly="readonly"
              @blur="el => $emit('updated-order-product-inventory-quantity', {
                inventory,
                quantity: parseFloat(el.target.value || 0)
              })"
            >
            <button
              v-show="!readonly"
              class="text-gray-500"
              @click="$emit('updated-order-product-inventory-quantity', {
                inventory,
                quantity: ((inventory.order_quantity + 1) > inventory.quantity) ? inventory.quantity : (inventory.order_quantity + 1)
              })"
            >+</button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-1">
      <f7-badge
        v-for="(feature, index) in product.features"
        :key="index"
        color="orange"
        class="mr-1"
      >
        {{ feature }}
      </f7-badge>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    modified: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.counter {
  display: flex;
  flex-direction: row;
  margin-top: 4px;
  color: #666;
}

.counter input[type="number"] {
  background-color: #eee !important;
  text-align: center;
  height: auto !important;
  padding: 4px 0;
  -webkit-appearance: none;
  flex: 3 0 0px;
}
.counter.highlight {
  color: #000;
}
.counter.highlight input[type="number"] {
  font-weight: bold;
  background-color: #000 !important;
  color: #fff !important;
}
.counter.modified input[type="number"] {
  font-weight: bold;
  background-color: red !important;
  color: #fff !important;
}
.counter.readonly input[type="number"] {
  border-radius: 4px;
}
.counter button {
  width: 40px;
  height: 30px;
  outline: none;
  border: 0;
  display: block;
  font-size: 20px;
  -webkit-appearance: none;
  background-color: #ccc;
  padding: 0 !important;
  text-align: center;
  flex: 1 0 12px;
}
.counter.highlight button {
  background-color: #000;
  color: #fff;
}
.counter.modified button {
  background-color: red;
  color: #fff;
}
.counter button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.counter button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
